import { ReactNode, useState } from "react";
import { SpriteIcon } from "components/UI/SpriteIcon";
import styles from "./Input.module.scss";
import uploadIcon from "public/img/icons/upload-alt.svg";
import fileIcon from "public/img/icons/file-alt.svg";
import closeIcon from "public/img/icons/close.svg";
import prettyBytes from "pretty-bytes";
import { useRef } from "react";

type InputFileProps = {
  name: string;
  onChange?: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  setFieldTouched?: (
    field: string,
    isTouched?: boolean | undefined,
    shouldValidate?: boolean | undefined
  ) => void;
  disabled?: boolean;
  error?: boolean | ReactNode;
};

export const InputFile = ({ name, onChange, disabled, error, setFieldTouched }: InputFileProps) => {
  const input = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string | null>(null);
  const [fileSize, setFileSize] = useState<number>(0);
  const handleChange = () => {
    if (input.current?.files?.length) {
      setFileName(input.current.files[0].name);
      setFileSize(input.current.files[0].size);
      setFieldTouched?.(name, true);
      onChange?.(name, input.current.files[0]);
    } else {
      setFileName(null);
      setFileSize(0);
      setFieldTouched?.(name, true);
      onChange?.(name, undefined);
    }
  };

  return (
    <div className={styles.inputFileWrap}>
      <div className={styles.inputFile}>
        <input
          type="file"
          name={name}
          accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ref={input}
          onChange={handleChange}
        />
        {!fileName && (
          <span className={styles.inputFilePlaceholder}>
            <SpriteIcon icon={uploadIcon} />
            <span className={styles.inputFilePlaceholderText}>Drop your essay here or click to upload</span>
            <span className={styles.fileExtension}>(doc, docx)</span>
          </span>
        )}
        {fileName && (
          <span className={styles.inputFileUploaded}>
            <span className={styles.inputFileName}>
              <SpriteIcon icon={fileIcon} /> <span>{fileName}</span>
            </span>

            <span className={styles.inputFileUploadedRight}>
              <span className={styles.fileSize}>{prettyBytes(fileSize)}</span>
              {!disabled && (
                <button
                  type="button"
                  className={styles.closeBtn}
                  onClick={() => {
                    if (input.current) {
                      // @ts-ignore
                      input.current.value = null;
                    }

                    handleChange();
                  }}
                >
                  <SpriteIcon icon={closeIcon} />
                </button>
              )}
            </span>
          </span>
        )}
      </div>
      {error && typeof error !== "boolean" && <span className={styles.inputErrorMsg}>{error}</span>}
    </div>
  );
};
